module.exports = __webpack_public_path__ + "img/alexion_logo.2f6f0b08.png";